import { render, staticRenderFns } from "./PageForbiddenPlatform.vue?vue&type=template&id=2bc52369"
import script from "./PageForbiddenPlatform.vue?vue&type=script&lang=js"
export * from "./PageForbiddenPlatform.vue?vue&type=script&lang=js"
import style0 from "./PageForbiddenPlatform.vue?vue&type=style&index=0&id=2bc52369&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports